/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Chat from './Chat';
import emptyimg from "../../assets/Image/emptyOrder.png";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';

const MyBooking = () => {

    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

    const [currentBooking, setCurrentBooking] = useState([]);
    const [pastBooking, setPastBooking] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showChat, setShowChat] = useState(false);
    const [selectDoc, setSelectDoc] = useState("");
    const [deviceCheck, setDeviceCheck] = useState(false);
    const [page, setPage] = useState(1);
    const [totallength, setTotalLength] = useState(0);

    const navigate = useNavigate();
    const SelectBtnRef = useRef(0);
    const hasReachedBottom = useRef(false);
    const NoMoreDataRef = useRef(true);

    const Userid = secureLocalStorage.getItem("Userid");

    useEffect(() => {
        HandleGetCurrentBooking(1);
    }, []);

    const HandleGetCurrentBooking = (page) => {
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/booked_appo_pending_list`, { id: Userid, page })
                .then((res) => {
                    console.log("booked_appo_pending_list", res);
                    const { pending_appoint_list, ResponseCode } = res.data;

                    if (ResponseCode === 200) {

                        if (pending_appoint_list.length === 0 || totallength > pending_appoint_list.length) {
                            NoMoreDataRef.current = false;
                        }

                        if (page === 1) {
                            setCurrentBooking(pending_appoint_list);
                            setTotalLength(pending_appoint_list.length);
                        } else {
                            setCurrentBooking(prev => [...prev, ...pending_appoint_list]);
                        }

                        setLoading(false);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };


    const HandleGetPastBooking = (page) => {
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/booked_appo_complete_list`, { id: Userid, page })
                .then((res) => {
                    console.log("booked_appo_complete_list", res);
                    const { complete_appoint_list, ResponseCode } = res.data;
                    if (ResponseCode === 200) {

                        if (complete_appoint_list.length === 0 || totallength > complete_appoint_list.length) {
                            NoMoreDataRef.current = false;
                        }

                        if (page === 1) {
                            setPastBooking(complete_appoint_list);
                            setTotalLength(complete_appoint_list.length);
                        } else {
                            setPastBooking(prev => [...prev, ...complete_appoint_list]);
                        }
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const clientHeight = window.innerHeight;

            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

            if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
                hasReachedBottom.current = true;
                setPage(prevPage => prevPage + 1);
            } else if (!isAtBottom && hasReachedBottom.current) {
                hasReachedBottom.current = false;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);

    useEffect(() => {
        if (page === 1 || !NoMoreDataRef.current) return;

        if (SelectBtnRef.current === 0) {
            HandleGetCurrentBooking(page);
        } else {
            HandleGetPastBooking(page);
        }

    }, [page]);

    const HandleBookingDetails = (id) => {
        sessionStorage.setItem("Appintmentid", id);
        navigate("/appointment-details", { state: { status: SelectBtnRef.current } });
    };

    const HandleChat = (e, Docid) => {
        e.stopPropagation();
        setShowChat(true);
        setSelectDoc(Docid);
    };

    const AudioCallHandler = async (e, code, phone) => {
        e.stopPropagation();

        try {
            const deviceList = await navigator.mediaDevices.enumerateDevices();
            let hasMicrophone = false;

            deviceList.forEach(device => {
                if (device.kind === 'audioinput') {
                    hasMicrophone = true;
                }
            });

            if (!hasMicrophone) {
                setDeviceCheck(true);
                return;
            }

        } catch (error) {
            console.error('Error checking devices:', error);
        }
        window.location.href = `tel:${code + phone}`;
    };

    const HadnleSelectButton = (index) => {
        SelectBtnRef.current = index;
        NoMoreDataRef.current = true;
        setPage(1);
        setTotalLength(0);
        if (index === 0) {
            HandleGetCurrentBooking(1);
        } else {
            HandleGetPastBooking(1);
        }
    }

    return (
        <div className='w-full width-container content-wrapper'>
            {loading
                ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
                : <div className="">
                    <div className="flex justify-center mt-[25px]">
                        <div className="bg-[#F6F7F8] Select-btn p-[5px] rounded-[50px] flex gap-[20px]">
                            <button onClick={() => HadnleSelectButton(0)} className={`${SelectBtnRef.current === 0 && "active"}`}>{t("Current Booking")}</button>
                            <button onClick={() => HadnleSelectButton(1)} className={`${SelectBtnRef.current === 1 && "active"}`}>{t("Past Booking")}</button>
                        </div>
                    </div>
                    <div className="mybooking">
                        {SelectBtnRef.current === 0
                            ? (currentBooking.length >= 1
                                ? currentBooking.map((item, index) => {
                                    const BgColor = item.status_type === "Pending" ? "bg-yellow-100" : item.status_type === "Service Start" ? "bg-orange-100" : "bg-blue-100";
                                    const Color = item.status_type === "Pending" ? "text-yellow-600" : item.status_type === "Service Start" ? "text-orange-500" : "text-blue-600";
                                    return <div onClick={() => HandleBookingDetails(item.id)} key={index} className="card-box">
                                        <div className="relative">
                                            <ImageLoad src={ImgBaseUrl + item.doc_logo} CustomeStyle={"object-cover"} alt={"doc_logo"} />
                                            <div className={`absolute top-[8px] right-[15px] px-[10px] rounded-[50px] ${BgColor}`}>
                                                <h1 className={`font-[500] ${Color}`}>{item.status_type}</h1>
                                            </div>
                                        </div>
                                        <div className="p-[10px]">
                                            <div className="flex items-center gap-[10px] justify-between">
                                                <p className='text-gray-500 font-[500]'>{item.depart_name}</p>
                                                <span className='font-[500] text-[16px] text-[#4038FF]'>{t("ID")} :- {item.id}</span>
                                            </div>
                                            <h1 className='text-[18px] font-[500]'>{item.name}</h1>
                                            <div className="text-gray-500 font-[500] flex items-center gap-[10px] mt-[5px]">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="#808080" strokeWidth="1.5" />
                                                    <path d="M3 9H21" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" />
                                                    <path d="M8 2L8 5" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M16 2V5" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <circle cx="12" cy="15" r="1" fill="#808080" />
                                                    <circle cx="16" cy="15" r="1" fill="#808080" />
                                                    <circle cx="8" cy="15" r="1" fill="#808080" />
                                                </svg>
                                                <h1 className='text-[14px]'>{item.appointment_date}, {item.appointment_time}</h1>
                                            </div>
                                            <div className="mt-[8px]">
                                                {item.show_type === "1"
                                                    ? <div className="text-[#4038FF] flex items-center gap-[5px]">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M18 2H6C3.79086 2 2 3.79086 2 6V18C2 19.8642 3.27532 21.4306 5.00111 21.8743C5.32039 21.9563 5.6551 22 6 22H18C18.3449 22 18.6796 21.9563 18.9989 21.8743C20.7247 21.4306 22 19.8642 22 18V6C22 3.79086 20.2091 2 18 2ZM15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9ZM7.15257 17.0155C7.70085 15.2824 9.66322 14 12 14C14.3368 14 16.2991 15.2824 16.8474 17.0155C17.014 17.5421 16.5523 18 16 18H8C7.44772 18 6.98599 17.5421 7.15257 17.0155Z" fill="#4038FF" />
                                                        </svg>
                                                        <h1 className='font-[500]'>{t("In Person")}</h1>
                                                    </div>
                                                    : <div className="text-[#4038FF] flex items-center gap-[5px]">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M2 8C2 5.79086 3.79086 4 6 4H12C14.2091 4 16 5.79086 16 8V16C16 18.2091 14.2091 20 12 20H6C3.79086 20 2 18.2091 2 16V8ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM18.5409 16.3103L17.5 15.1999V8.79993L18.5409 7.68961C19.781 6.3669 22 7.24442 22 9.05749V14.9424C22 16.7554 19.781 17.633 18.5409 16.3103Z" fill="#4038FF" />
                                                        </svg>
                                                        <h1 className='font-[500]'>{t("Video Visit")}</h1>
                                                    </div>}
                                            </div>
                                            <div className="mt-[10px] flex items-center gap-[10px]">
                                                <button onClick={(e) => HandleChat(e, item.did)} className='btn'>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8 10H16M8 14H12M11 3H13C17.9706 3 22 7.02944 22 12C22 16.9706 17.9706 21 13 21H6C3.79086 21 2 19.2091 2 17V12C2 7.02944 6.02944 3 11 3Z" stroke="#28303F" strokeWidth="1.5" strokeLinecap="round" />
                                                    </svg>
                                                    {t("Message")}
                                                </button>
                                                <button onClick={(e) => AudioCallHandler(e, item.country_code, item.phone)} className='btn'>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M21 19V17.3541C21 16.5363 20.5021 15.8008 19.7428 15.4971L17.7086 14.6835C16.7429 14.2971 15.6422 14.7156 15.177 15.646L15 16C15 16 12.5 15.5 10.5 13.5C8.5 11.5 8 9 8 9L8.35402 8.82299C9.28438 8.35781 9.70285 7.25714 9.31654 6.29136L8.50289 4.25722C8.19916 3.4979 7.46374 3 6.64593 3H5C3.89543 3 3 3.89543 3 5C3 13.8366 10.1634 21 19 21C20.1046 21 21 20.1046 21 19Z" stroke="#28303F" strokeWidth="1.5" strokeLinejoin="round" />
                                                    </svg>
                                                    {t("Call")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                })
                                : <div className='h-[400px] justify-center flex flex-col mx-auto items-center text-center'>
                                    <img src={emptyimg} className='w-[200px]' alt="" />
                                    <h1 className='font-[500] text-[18px]'>{t("No Booking placed !!")}</h1>
                                    <p className='text-gray-400'>{t("Currently you don't have any Booking")}</p>
                                </div>)
                            : (pastBooking.length >= 1
                                ? pastBooking.map((item, index) => {
                                    const BgColor = item.status_type === "Canceled" ? "bg-red-100" : "bg-green-100";
                                    const Color = item.status_type === "Canceled" ? "text-red-500" : "text-green-700";

                                    return <div key={index} onClick={() => HandleBookingDetails(item.id)} className="card-box">
                                        <div className="relative">
                                            <ImageLoad src={ImgBaseUrl + item.doc_logo} CustomeStyle={"object-cover"} alt={"doc_logo"} />
                                            <div className={`absolute top-[8px] right-[15px] px-[10px] rounded-[50px] ${BgColor}`}>
                                                <h1 className={`font-[500] ${Color}`}>{item.status_type}</h1>
                                            </div>
                                        </div>
                                        <div className="p-[10px]">
                                            <div className="flex items-center gap-[10px] justify-between">
                                                <p className='text-gray-500 font-[500]'>{item.depart_name}</p>
                                                <span className='font-[500] text-[16px] text-[#4038FF]'>{t("ID")} :- {item.id}</span>
                                            </div>
                                            <h1 className='text-[18px] font-[500]'>{item.name}</h1>
                                            <div className="text-gray-500 font-[500] flex items-center gap-[10px] mt-[5px]">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="#808080" strokeWidth="1.5" />
                                                    <path d="M3 9H21" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" />
                                                    <path d="M8 2L8 5" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M16 2V5" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <circle cx="12" cy="15" r="1" fill="#808080" />
                                                    <circle cx="16" cy="15" r="1" fill="#808080" />
                                                    <circle cx="8" cy="15" r="1" fill="#808080" />
                                                </svg>
                                                <h1 className='text-[14px]'>{item.appointment_date}, {item.appointment_time}</h1>
                                            </div>
                                            <div className="mt-[8px]">
                                                {item.show_type === "1"
                                                    ? <div className="text-[#4038FF] flex items-center gap-[5px]">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M18 2H6C3.79086 2 2 3.79086 2 6V18C2 19.8642 3.27532 21.4306 5.00111 21.8743C5.32039 21.9563 5.6551 22 6 22H18C18.3449 22 18.6796 21.9563 18.9989 21.8743C20.7247 21.4306 22 19.8642 22 18V6C22 3.79086 20.2091 2 18 2ZM15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9ZM7.15257 17.0155C7.70085 15.2824 9.66322 14 12 14C14.3368 14 16.2991 15.2824 16.8474 17.0155C17.014 17.5421 16.5523 18 16 18H8C7.44772 18 6.98599 17.5421 7.15257 17.0155Z" fill="#4038FF" />
                                                        </svg>
                                                        <h1 className='font-[500]'>{t("In Person")}</h1>
                                                    </div>
                                                    : <div className="text-[#4038FF] flex items-center gap-[5px]">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M2 8C2 5.79086 3.79086 4 6 4H12C14.2091 4 16 5.79086 16 8V16C16 18.2091 14.2091 20 12 20H6C3.79086 20 2 18.2091 2 16V8ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM18.5409 16.3103L17.5 15.1999V8.79993L18.5409 7.68961C19.781 6.3669 22 7.24442 22 9.05749V14.9424C22 16.7554 19.781 17.633 18.5409 16.3103Z" fill="#4038FF" />
                                                        </svg>
                                                        <h1 className='font-[500]'>{t("Video Visit")}</h1>
                                                    </div>}
                                            </div>
                                            <div className="mt-[10px] flex items-center gap-[10px]">
                                                <button onClick={(e) => HandleChat(e, item.did)} className='btn'>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8 10H16M8 14H12M11 3H13C17.9706 3 22 7.02944 22 12C22 16.9706 17.9706 21 13 21H6C3.79086 21 2 19.2091 2 17V12C2 7.02944 6.02944 3 11 3Z" stroke="#28303F" strokeWidth="1.5" strokeLinecap="round" />
                                                    </svg>
                                                    {t("Message")}
                                                </button>
                                                <button onClick={(e) => AudioCallHandler(e, item.country_code, item.phone)} className='btn'>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M21 19V17.3541C21 16.5363 20.5021 15.8008 19.7428 15.4971L17.7086 14.6835C16.7429 14.2971 15.6422 14.7156 15.177 15.646L15 16C15 16 12.5 15.5 10.5 13.5C8.5 11.5 8 9 8 9L8.35402 8.82299C9.28438 8.35781 9.70285 7.25714 9.31654 6.29136L8.50289 4.25722C8.19916 3.4979 7.46374 3 6.64593 3H5C3.89543 3 3 3.89543 3 5C3 13.8366 10.1634 21 19 21C20.1046 21 21 20.1046 21 19Z" stroke="#28303F" strokeWidth="1.5" strokeLinejoin="round" />
                                                    </svg>
                                                    {t("Call")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                })
                                : <div className='h-[400px] justify-center flex flex-col mx-auto items-center text-center'>
                                    <img src={emptyimg} className='w-[200px]' alt="" />
                                    <h1 className='font-[500] text-[18px]'>{t("No Booking placed !!")}</h1>
                                    <p className='text-gray-400'>{t("Currently you don't have any Booking")}</p>
                                </div>)
                        }
                    </div>
                </div>
            }

            {showChat && <div onClick={() => setShowChat(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="chat_bottom">
                    <Chat index={1} setShowChat={setShowChat} doctorId={selectDoc} />
                </div>
            </div>}

            {deviceCheck && <div onClick={() => setDeviceCheck(false)} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-[15px] p-4">
                    <h6 className='m-0 font-[500] text-[18px] text-gray-600'>{t("Required for voice and video calls. Make")} <br /> {t("sure your audio device (headset, speakers,")}<br /> {t("or microphone) is connected and working.")}</h6>
                </div>
            </div>}

        </div >
    )
}

export default MyBooking
/* jshint ignore:end */